<template>
  <div class="category-style-page">
    <van-nav-bar
      :title="tagValue"
      left-text="返回"

      left-arrow
      @click-left="goback"

    />
    <van-list
       style="padding-top: 10px;"
        v-model="loading"
        :finished="finished"
        finished-text="没有更多了"
        @load="getStyleData"
    >
      <div @click="gotoDesignDetail(item.id)" class="series" :key="index" v-for="(item, index) in styles">

<!--        <div v-if="productType=='LianTou'" class="info-img-liantou" :style="{backgroundImage:'url('+item.imageUrl+')'}"></div>-->
<!--        <img v-if="productType!='LianTou'" :src="item.imageUrl"/>-->
        <van-image :style="productType=='LianTou'?'height: 110px;':'min-height: 180px'" lazy-load class="img" fit="contain" position="center" :src="item.imageUrl"/>
        <div class="info-top">
          <div class="title">{{ item.name }}</div>
          <div class="price-2" v-if="item.price">
            ¥<span class="price-color">{{ item.price }}元</span>/{{ item.unitName }}
          </div>
        </div>
        <div class="tags">
          <div class="tag">
            <span v-if="item.zhuBuProductName">主布:{{ item.zhuBuProductName }}</span>
            <span v-if="item.peiBuBuProductName">配布:{{ item.peiBuBuProductName }}</span>
          </div>
          <!--<div class="tag" :key="$item" v-for="$item in item.tags">
            {{ $item }}
          </div>-->
        </div>
      </div>
    </van-list>
  </div>
</template>

<script>
export default {
  name: "CategoryStylePage",
  components: {},
  data() {
    return {
      loading: false,
      finished: false,
      styles: [],
      tagId: null,
      productType: null,
      tagValue: null,
      page: 1,
      pageNum: 10,
    };
  },

  mounted() {
    this.tagValue = this.$route.query.tagValue
    document.title = this.tagValue || '款式列表'
    this.tagId = this.$route.query.tagId
    this.productType = this.$route.query.productType
    // this.getStyleData()

  },

  methods: {
    goback(){
      history.go(-1)
    },
    gotoDesignDetail(id) {
      if(this.productType == 'LianTou') {
        this.$router.push('./designltdetail?id=' + id);
      } else {
        this.$router.push('./designdetail?id=' + id);
      }
    },
    getStyleData() {

      this.$http.post("/public/goods", {
        "smartCurtainProductType": this.productType,
        "tagId": this.tagId
      }).then(res => {
        this.loading = false
        this.finished = true
        this.styles = res
      });
    },
  },
};
</script>
<style scoped>
.category-style-page {
  background: #f1f1f1;
  min-height: 100vh;
  /* padding-top: 10px; */
}

.van-list {
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
  margin-left: 10px;
}

.series {
  flex: 0 0 calc(50% - 10px);
  background: #fff;
  border-radius: 6px;
  margin-right: 10px;
  margin-bottom: 10px;
}

.series img {
  max-width: 100%;
}

.info-img-liantou {
  min-height: 110px;
  background: no-repeat center center;
  background-size: 100%;
}

.info-img {
  min-height: 180px;
  /*background: no-repeat top center;*/
  /*background-size: cover;*/
  object-fit: contain;
}

.info-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 10px;
}

.series .tags {
  display: flex;

  padding: 0 10px 10px;
  font-size: 12px;
  align-items: center;
}

.series .tags .tag {
  color:#9B9B9B;
  margin-right: 10px;
}

.series .price-2 {
  font-size: 10px;
}

.price-color {
  color: var(--price-color);
  font-size: 14px;
  margin: 0 2px;
}

#app {
  padding-bottom: 0;
}
</style>
